module.exports = require("@aofl/element");